export default __webpack_public_path__ + "static/media/bg-career-banner.d77df898.jpg";